import { BASE_URL } from "../constants/app.constants";

export const URL = {
  SUBMIT_USER_REVIEW: BASE_URL + "reviews",
  GET_USER_REVIEW: BASE_URL + "reviews",
};
